'use client';

import type { MutableRefObject } from 'react';
import { useEffect, useState } from 'react';

export function useIsVisible<T extends Element>(
  ref: MutableRefObject<T | null>,
) {
  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    if (ref.current) {
      const observer = new IntersectionObserver(([entry]) => {
        setVisible(entry.isIntersecting);
      });

      observer.observe(ref.current);

      return () => {
        observer.disconnect();
      };
    }

    return undefined;
  }, [ref]);

  return isVisible;
}
